import { lazy, Suspense, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/lib/auth";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

import Accueil from "@/pages/Accueil";
import Nouveautes from "@/pages/Nouveautes";
import Actualites from "@/pages/Actualites";
import Livres from "@/pages/Livres";
import BookDetail from "@/pages/BookDetail";
import Auteurs from "@/pages/Auteurs";
import Gazette from "@/pages/Gazette";
import LecturesRecommandees from "@/pages/LecturesRecommandees";
import Soumission from "@/pages/Soumission";
import Contact from "@/pages/Contact";
import { MentionsLegales, CGV } from "@/pages/Legal";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AuthCallback from "@/pages/AuthCallback";
import ExtractRead from "@/pages/ExtractRead";
import Histoires from "@/pages/Histoires";
import Desinscription from "@/pages/Desinscription";
import ExtractPoster from "@/pages/ExtractPoster";
import PartnerLanding from "@/pages/PartnerLanding";
import PartnerPoster from "@/pages/PartnerPoster";
const MyBook = lazy(() => import("@/pages/MyBook"));
const PaymentResult = lazy(() => import("@/pages/PaymentResult"));
const ReviewPage = lazy(() => import("@/pages/ReviewPage"));

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

// Detect OAuth session_id during render (not useEffect) to prevent race conditions
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  const isAdminRoute = location.pathname.startsWith("/admin") || location.pathname.startsWith("/histoires/") || location.pathname.startsWith("/p/") || location.pathname.startsWith("/mon-livre/") || location.pathname.startsWith("/paiement/") || location.pathname.startsWith("/avis/");
  return (
    <>
      <ScrollToTop />
      {!isAdminRoute && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<Accueil />} />
          <Route path="/nouveautes" element={<Nouveautes />} />
          <Route path="/actualites" element={<Actualites />} />
          <Route path="/livres" element={<Livres />} />
          <Route path="/livres/:id" element={<BookDetail />} />
          <Route path="/auteurs" element={<Auteurs />} />
          <Route path="/gazette" element={<Gazette />} />
          <Route path="/lectures-recommandees" element={<LecturesRecommandees />} />
          <Route path="/soumission" element={<Soumission />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/cgv" element={<CGV />} />
          <Route path="/histoires" element={<Histoires />} />
          <Route path="/p/:code" element={<PartnerLanding />} />
          <Route path="/p/:code/affiche" element={<PartnerPoster />} />
          <Route path="/desinscription" element={<Desinscription />} />
          <Route path="/histoires/:slug" element={<ExtractRead />} />
          <Route path="/histoires/:slug/affiche" element={<ExtractPoster />} />
          <Route path="/avis/:token" element={<Suspense fallback={null}><ReviewPage /></Suspense>} />
          <Route path="/paiement/:tx" element={<Suspense fallback={null}><PaymentResult /></Suspense>} />
          <Route path="/mon-livre/:token" element={<Suspense fallback={<p className="p-12 font-body text-[#757575]">Chargement…</p>}><MyBook /></Suspense>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </main>
      {!isAdminRoute && <Footer />}
      <Toaster position="bottom-right" />
    </>
  );
}

function App() {
  return (
    <div className="App bg-[#FAF9F6]">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
